module.exports = __webpack_public_path__ + "img/DSC0455.75294db3.jpg";